import { authedAxios } from '../../utils'
import { useEffect, useState } from 'react'

const useCustomerRevenueSummary = (customerId, refreshDeps = []) => {
  const [customerRevenueSummary, setCustomerRevenueSummary] = useState(null)

  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadError, setHasLoadError] = useState(false)

  const getCustomerRevenueSummary = () => {
    return authedAxios
      .get(`/api/customer/${customerId}/revenue-summary`)
      .then((res) => {
        setIsLoading(false)
        setCustomerRevenueSummary(res.data.customerRevenueSummary)
      })
      .catch((e) => {
        setHasLoadError(true)
      })
  }

  useEffect(() => {
    if (!customerId || customerId === 'new') return
    getCustomerRevenueSummary()
  }, [customerId, ...refreshDeps])

  return {
    customerRevenueSummary,
    isLoading,
    hasLoadError,
  }
}

export default useCustomerRevenueSummary
